// extracted by mini-css-extract-plugin
export var md = "_2k-4";
export var semantic = "_2k-5";
export var sm = "_2k-3";
export var text = "_2k-6";
export var toggleInput = "_2k-0";
export var toggleSwitch = "_2k-1";
export var xs = "_2k-2";